





































import Vue from 'vue';
import Multiselect from 'vue-multiselect';
export default Vue.extend({
    components: {
        'vue-multiselect': Multiselect,
    },
    props: {
        value: {
            type: [Object, String],
            required: false,
            default: null,
        },
        options: {
            type: Array,
            required: true,
        },
        placeholder: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        hasError: {
            type: Boolean,
            default: false,
        },
    },
});
